import authActionTypes from "containers/Auth/_actions";
import farmActionTypes from "containers/Farm/_actions";
import actionTypes from "./_actions";

const INITIAL_STATE = {
    myUserInvitations: null,
    myFarmAccessInvitations: null,
    myFarmAccessRequests: null,
    myFarms: null,
    myFarmGroups: null,
    accessInvitations: null,
};

const dashboardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // My Farm Group Invitations
        case actionTypes.DAHSBOARD_GET_MY_FARM_GROUP_INVITES:
            return {
                ...state,
                myFarmGroupInvitesLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_GROUP_INVITES_SUCCESS:
            return {
                ...state,
                myFarmGroupInvites: action.payload,
                myFarmGroupInvitesLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_GROUP_INVITES_FAILURE:
            return {
                ...state,
                myFarmGroupInvitesLoading: false,
            };

        // My User Invitations
        case actionTypes.DAHSBOARD_GET_MY_USER_INVITATIONS:
            return {
                ...state,
                myUserInvitationsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_USER_INVITATIONS_SUCCESS:
            return {
                ...state,
                myUserInvitations: action.payload,
                myUserInvitationsLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_USER_INVITATIONS_FAILURE:
            return {
                ...state,
                myUserInvitationsLoading: false,
            };

        // My Farm Access Invitations
        case actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS:
            return {
                ...state,
                myFarmAccessInvitationsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_SUCCESS:
            return {
                ...state,
                myFarmAccessInvitations: action.payload,
                myFarmAccessInvitationsLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_FAILURE:
            return {
                ...state,
                myFarmAccessInvitationsLoading: false,
            };

        //  Access Invitations
        case actionTypes.DAHSBOARD_GET_ACCESS_INVITATIONS:
            return {
                ...state,
                accessInvitationsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_ACCESS_INVITATIONS_SUCCESS:
            return {
                ...state,
                accessInvitations: action.payload,
                accessInvitationsLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_ACCESS_INVITATIONS_FAILURE:
            return {
                ...state,
                accessInvitationsLoading: false,
            };

        // My Farms
        case actionTypes.DAHSBOARD_GET_MY_FARMS:
            return {
                ...state,
                myFarmsLoading: true,
                myFarmsForceReload: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARMS_SUCCESS:
            return {
                ...state,
                myFarms: action.payload,
                myFarmsLoading: false,
                myFarmsForceReload: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARMS_FAILURE:
            return {
                ...state,
                myFarmsLoading: false,
                myFarmsForceReload: false,
            };

        // My Publications Summary
        case actionTypes.DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY:
            return {
                ...state,
                myPublicationsSummaryLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                myPublicationsSummary: action.payload,
                myPublicationsSummaryLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_FAILURE:
            return {
                ...state,
                myPublicationsSummaryLoading: false,
            };

        // My Recent Publications
        case actionTypes.DAHSBOARD_GET_MY_RECENT_PUBLICATIONS:
            return {
                ...state,
                myRecentPublicationsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_SUCCESS:
            return {
                ...state,
                myRecentPublications: action.payload,
                myRecentPublicationsLoading: false,
            };
        case actionTypes.DDAHSBOARD_GET_MY_RECENT_PUBLICATIONS_FAILURE:
            return {
                ...state,
                myRecentPublicationsLoading: false,
            };

        // My Farm Groups
        case actionTypes.DAHSBOARD_GET_MY_FARM_GROUPS:
            return {
                ...state,
                myFarmGroupsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_GROUPS_SUCCESS:
            return {
                ...state,
                myFarmGroups: action.payload,
                myFarmGroupsLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_GROUPS_FAILURE:
            return {
                ...state,
                myFarmGroupsLoading: false,
            };

        // My Farm Access Requests
        case actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS:
            return {
                ...state,
                myFarmAccessRequestsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_SUCCESS:
            return {
                ...state,
                myFarmAccessRequests: action.payload,
                myFarmAccessRequestsLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_FAILURE:
            return {
                ...state,
                myFarmAccessRequestsLoading: false,
            };

        // My Announcements
        case actionTypes.DAHSBOARD_GET_MY_ANNOUNCEMENTS:
            return {
                ...state,
                myAnnouncementsLoading: true,
            };
        case actionTypes.DAHSBOARD_GET_MY_ANNOUNCEMENTS_SUCCESS:
            return {
                ...state,
                myAnnouncements: action.payload,
                myAnnouncementsLoading: false,
            };
        case actionTypes.DAHSBOARD_GET_MY_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                myAnnouncementsLoading: false,
            };

        case actionTypes.DAHSBOARD_DISMISS_ANNOUNCEMENT_SUCCESS:
            return {
                ...state,
                myAnnouncements: (state.myAnnouncements || []).filter((m) => m.id !== action.payload),
            };

        // Toggle My Farm
        case farmActionTypes.TOGGLE_MY_FARM_SUCCESS: {
            const isExistingMyFarm = state.myFarms && state.myFarms.some((farm) => farm.id === action.payload.id);

            return {
                ...state,
                myFarmsForceReload: isExistingMyFarm ? false : true,
                myFarms:
                    state.myFarms &&
                    state.myFarms.map((farm) => {
                        if (farm.id !== action.payload.id) return farm;

                        return {
                            ...farm,
                            isMyFarm: action.payload.isMyFarm,
                        };
                    }),
                myRecentPublications: (state.myRecentPublications || []).map((publication) => {
                    if (publication.farmId !== action.payload.id) return publication;

                    return {
                        ...publication,
                        isMyFarm: action.payload.isMyFarm,
                    };
                }),
            };
        }
        case authActionTypes.AUTH_CLEAR_STORAGE:
            return INITIAL_STATE;

        default:
            return state;
    }
};

export default dashboardReducer;
